/**
 * Generates a consistent background color for avatars based on a string input
 *
 * @param text - The text to generate a color for (e.g., organization name)
 * @returns A CSS color string
 */ export function generateOrgColor(orgName) {
    let hash = 0;
    for(let i = 0; i < orgName.length; i++){
        hash = orgName.charCodeAt(i) + ((hash << 5) - hash);
    }
    const r = hash >> 16 & 0xff;
    const g = hash >> 8 & 0xff;
    const b = hash & 0xff;
    return "#".concat([
        r,
        g,
        b
    ].map((x)=>x.toString(16).padStart(2, '0')).join(''), "80");
}
/**
 * Gets the initials from a text string
 *
 * @param text - The text to get initials from
 * @param maxLength - Maximum number of characters to return (default: 2)
 * @returns The initials string
 */ export function getInitials(text) {
    let maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    if (!text) return '';
    const words = text.trim().split(/\s+/);
    if (words.length === 1) {
        return text.slice(0, maxLength).toUpperCase();
    }
    return words.slice(0, maxLength).map((word)=>word.charAt(0)).join('').toUpperCase();
}
